import {
  computed,
  Injectable,
  Signal,
  signal,
  WritableSignal,
} from '@angular/core';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import { WageDecision } from './interfaces/wage-decision.interface';

@Injectable({
  providedIn: 'root',
})
export class MasterWageDataService {
  /**
   * Signal that stores the status of the Wage Decision form that corresponds to the first step to create a new master wage
   */
  private readonly wageDecisionsFields: WritableSignal<WageDecision> = signal(
    {} as WageDecision
  );
  _wageDecisionsFields = computed(() => this.wageDecisionsFields());

  /**
   * Function that sets a new value for signal wageDecisionsFields
   * @param {WageDecision} wageDecisions
   */
  setWageDecisionFields(wageDecisions: WageDecision): void {
    this.wageDecisionsFields.set(wageDecisions);
  }
  selectedJurisdictionLocation$: BehaviorSubject<any> =
    new BehaviorSubject<any>(undefined);
  setSelectedJurisdictionLocation(obj: any): void {
    this.selectedJurisdictionLocation$.next(obj);
  }
  getSelectedJurisdictionLocation() {
    return this.selectedJurisdictionLocation$.asObservable();
  }

  /****************************************************************
   * Authorized Jurisdiction Properties that Rates Depends on:
   * authorizedTenantId, wageAccessTypeId, canCopyMaster,
   * wageAccessType, name, accessType, permissions[]
   * @subscribes to update these properties in the rates
   ****************************************************************/
  selectedAuthorizedJurisdiction$: BehaviorSubject<any> =
    new BehaviorSubject<any>(undefined);
  setAuthorizedJurisdiction(obj: any): void {
    this.selectedAuthorizedJurisdiction$.next(obj);
  }
  getAuthorizedJurisdiction() {
    return this.selectedAuthorizedJurisdiction$.asObservable();
  }
}
